// @flow
import React from 'react';
import styles from './alertsBar.scss';

type Props = {
  message: string,
  loading: boolean
};

const AlertsBar = ({ message, loading }: Props) => (
  <div className={` ${styles.alertIcnWrapper} l-row a-center j-center `}>
    {!loading ? (
      <div className={`${styles.alertBackdrop} l-row a-center j-center`}>
        <div className={`${styles.alertText} l-column j-center a-center`}>
          {message}
        </div>
      </div>
    ) : null}
  </div>
);

export default AlertsBar;
